<template>
  <q-dialog 
    :visible="isVisible" 
    title="调账" 
    width="500px" 
    :innerScroll="false" 
    @close="onCancel"
    @cancel="onCancel"
    @confirm="confirm"
    
  >
    <el-form :model="ruleForm" :rules="rules" ref="formRef" size="small" label-width="100px">
      <el-form-item label="经销商编码" prop="customerCode">
        <el-input v-model="ruleForm.customerCode" @blur="getCusWalletInfo"></el-input>
      </el-form-item>
      <el-form-item label="经销商名称" prop="customerName">
        <el-input v-model="ruleForm.customerName" disabled></el-input>
      </el-form-item>
      <el-form-item label="钱包类型">
        <el-select v-model="ruleForm.walletType" @change="getWalletTypeInfo" placeholder="请选择钱包类型">
          <el-option label="新钱包" value="8"></el-option>
          <el-option label="老钱包" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="钱包余额" prop="walletBalanceMinute">
        <el-input v-model="ruleForm.walletBalanceMinute" disabled></el-input>
      </el-form-item>
      <el-form-item label="调账金额" prop="adjustAmount">
        <el-input v-model="ruleForm.adjustAmount" type="number" @blur="blurAdjustAmount">
          <template slot="prepend">减少</template>
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      <el-form-item label="申请人" prop="applyUser">
        <el-input v-model="ruleForm.applyUser"></el-input>
      </el-form-item>
      <el-form-item label="申请原因" prop="applyReason">
        <el-input v-model="ruleForm.applyReason" type="textarea"></el-input>
      </el-form-item>
     
    </el-form>
  </q-dialog>
</template>

<script>
export default {
  props: {
    // 重新对外暴露visible，控制显示隐藏
    isShowAdjustDialog: {
      type: Boolean,
      default: false,
    },
    money: {
      type: Number,
      default: 0
    }
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.isShowAdjustDialog;
      },
      set(val) {
        this.$emit("update:isShowAdjustDialog", val);
      },
    },
  },
  data() {
    return {
      ruleForm: {
        customerCode: '',
        customerId: '',
        customerName: '',
        walletType: '8',
        walletBalance: '',
        adjustAmount: '',
        applyUser: '',
        applyReason: '',
      },
      rules: {
        customerCode: [
          { required: true, message: '请输入经销商编码', trigger: 'blur' },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        adjustAmount: [
          { required: true, message: '请输入调账金额', trigger: 'blur' },
        ],
        applyUser: [
          { required: true, message: '请输入申请人', trigger: 'blur' },
        ],
        applyReason: [
          { required: true, message: '请输入申请原因', trigger: 'blur' },
        ],
      },
      cusWalletInfo: {},
    };
  },
  methods: {
    getCusWalletInfo() {
      const { customerCode } = this.ruleForm
      if (!customerCode) return
      this.$api.dataReport.getCusWalletInfo(customerCode)
        .then(res => {
          if (res.data) {
            const { customerName,customerId } = res.data
            this.ruleForm.customerName = customerName
            this.ruleForm.customerId = customerId
            this.cusWalletInfo = res.data
            this.getWalletTypeInfo()
          } else {
            this.$refs.formRef.resetFields();
          }
         
        })
    },
    getWalletTypeInfo() {
      const { walletType } = this.ruleForm
      const info = this.cusWalletInfo.walletList.find(item => item.walletType == walletType)
      this.ruleForm.walletBalance = info.walletBalance
      this.ruleForm.walletBalanceMinute = info.walletBalance ? info.walletBalance / 100 : info.walletBalance
      this.ruleForm.walletId = info.walletId
      this.ruleForm.adjustAmount = ''
    },
    blurAdjustAmount() {
      const { adjustAmount,walletBalance } = this.ruleForm
      if (adjustAmount > walletBalance) {
        this.ruleForm.adjustAmount = walletBalance
      }
    },
    confirm() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.$api.dataReport.adjustBalance(this.ruleForm)
          .then(res => {
            this.$message({
              type: 'success',
              message: '调账成功',
            });
            this.onCancel()
            this.$emit('adjustBalanceSuccess')
          })
        }
      });
    },
    onCancel() {
      this.$refs.formRef.resetFields();
      this.ruleForm.walletType = '8'
      this.isVisible = false;
    }
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-select {
  width: 100%;
}
</style>
